import { render, staticRenderFns } from "./BiChartComponent.vue?vue&type=template&id=8c7cd118"
import script from "./BiChartComponent.ts?vue&type=script&lang=ts&external"
export * from "./BiChartComponent.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports